module.exports = __webpack_public_path__ + "img/ch21_06_天台星夜.b22d3717.jpg";